module.exports = __webpack_public_path__ + "static/media/fatcat2.550c7189.png";